import React from 'react';
import moment from 'moment';

const Leaderboard = ({ leaderboards }) => {

    const data = [
        { 
            score: 100,
            date: '2020-01-01',
            name: 'Unnamed Team', 
            players: {
                active: 4,
                allowed: 8,
            },
            time: {
                remaining: '43:12',
                original: '60:00',
            },
        },
    ]

    return (
        <div className='mr-[300px] p-12 items-center justify-center flex'>

            <table className='w-75'>
                <thead>
                    <tr className='text-gray-100'>
                        <th>#</th>
                        <th>Date</th>
                        <th>Team</th>
                        <th>Players</th>
                    </tr>
                </thead>

            <tbody>
                {data.map((item, index) => (
                    <tr key={index} className='even:bg-gray-700 odd:bg-gray-800 text-gray-100'>
                        <td>{index +1}</td>
                        <td>{item.name}</td>
                        <td>{moment(item.date).format('LLL')}</td>
                        <td>{item.players.active}/{item.players.allowed}</td>
                    </tr>
                ))}
            </tbody>

            </table>

           
            
            
        </div>
    );
};

export default Leaderboard;
